import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Routes as AppRoutes } from './infrastructure/routes';
import { ForbiddenPageComponent } from './ui/pages/forbidden-page/forbidden-page.component';
import { HomePageComponent } from './ui/pages/home-page/home-page.component';
import { LoginPageComponent } from './ui/pages/login-page/login-page.component';
import { SignupPageContactComponent } from './ui/pages/signup-page/signup-page-contact/signup-page-contact.component';
import { SignupPageCompanyComponent } from './ui/pages/signup-page/signup-page-company/signup-page-company.component';
import { SignupPageImportAddInfoComponent } from './ui/pages/signup-page/signup-page-import-add-info/signup-page-import-add-info.component';
import { SignupInvitationcodeComponent } from './ui/pages/signup-page/signup-invitationcode/signup-invitationcode.component';
import { UserDashboardComponent } from './ui/components/user-dashboard/user-dashboard.component';
import { UserContactInfoComponent } from './ui/pages/user-dashboard-pages/user-contact-info/user-contact-info.component';
import { UserCompanyInfoComponent } from './ui/pages/user-dashboard-pages/user-company-info/user-company-info.component';
import { UserProductsComponent } from './ui/pages/user-dashboard-pages/user-products/user-products.component';
import { UserFridgestoragesComponent } from './ui/pages/user-dashboard-pages/user-fridgestorages/user-fridgestorages.component';
import { UserConsigneesComponent } from './ui/pages/user-dashboard-pages/user-consignees/user-consignees.component';
import { FridgestorageFormComponent } from './ui/pages/user-dashboard-pages/user-fridgestorages/fridgestorage-form/fridgestorage-form.component';
import { UserNotifiesComponent } from './ui/pages/user-dashboard-pages/user-notifies/user-notifies.component';
import { ConsigneeFormComponent } from './ui/pages/user-dashboard-pages/user-consignees/consignee-form/consignee-form.component';
import { NotifierFormComponent } from './ui/pages/user-dashboard-pages/user-notifies/notifier-form/notifier-form.component';
import { UserChangePasswordComponent } from './ui/pages/user-dashboard-pages/user-change-password/user-change-password.component';
import { ResetPasswordRequestPageComponent } from './ui/pages/reset-password-request-page/reset-password-request-page.component';
import { ResetPasswordPageComponent } from './ui/pages/reset-password-page/reset-password-page.component';
import { UserNotificationsConfigComponent } from './ui/pages/user-dashboard-pages/user-notifications/user-notifications-config.component';
import { UserSupportComponent } from './ui/pages/user-dashboard-pages/user-support/user-support.component';
import { MarketplacePageComponent } from './ui/pages/marketplace-page/marketplace-page.component';
import { UserExportOffersComponent } from './ui/pages/user-dashboard-pages/user-export-offers/user-export-offers.component';
import { NewExportOfferComponent } from './ui/pages/user-dashboard-pages/user-export-offers/new-export-offer/new-export-offer.component';
import { UserProductCertificatesComponent } from './ui/pages/user-dashboard-pages/user-product-certificates/user-product-certificates.component';
import { ProductCertificateFormComponent } from './ui/pages/user-dashboard-pages/user-product-certificates/product-certificate-form/product-certificate-form.component';
import { PurchaseOrdersPageComponent } from './ui/pages/purchase-orders-page/purchase-orders-page.component';
import { ContainerOrderPageComponent } from './ui/pages/container-order-page/container-order-page.component';
import { UserPurchaseOrdersComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/user-purchase-orders.component';
import { VerifyPalletsPageComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/verify-pallets-page/verify-pallets-page.component';
import { OrderDetailComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/order-detail/order-detail.component';
import { EditExportOfferComponent } from './ui/pages/user-dashboard-pages/user-export-offers/edit-export-offer/edit-export-offer.component';
import { AdminManageOrdersPageComponent } from './ui/pages/admin-dashboard-pages/admin-manage-orders-page/admin-manage-orders-page.component';
import { UserBargainingComponent } from './ui/pages/user-dashboard-pages/user-bargaining/user-bargaining.component';
import { BargainingDetailComponent } from './ui/pages/user-dashboard-pages/user-bargaining/bargaining-detail/bargaining-detail.component';
import { AdminOrderDetailComponent } from './ui/pages/admin-dashboard-pages/admin-manage-orders-page/order-detail/admin-order-detail.component';
import { AuthGuard } from './infrastructure/guards/auth.guard';
import { RolesGuard } from './infrastructure/guards/roles.guard';
import { AdminVerifyPalletsComponent } from './ui/pages/admin-dashboard-pages/admin-manage-orders-page/admin-verify-pallets/admin-verify-pallets.component';
import { AdminCompleteOrderComponent } from './ui/pages/admin-dashboard-pages/admin-manage-orders-page/admin-complete-order/admin-complete-order.component';
import { UserNotificationsComponent } from './ui/pages/user-dashboard-pages/user-notifications/notifications/user-notifications/user-notifications.component';
import { UserExportOfferSuggestionsComponent } from './ui/pages/user-dashboard-pages/user-export-offer-suggestions/user-export-offer-suggestions.component';
import { AdminDeliveryComponent } from './ui/pages/admin-dashboard-pages/admin-manage-orders-page/admin-delivery/admin-delivery.component';
import { ConfirmPurchasePageComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/confirm-purchase-page/confirm-purchase-page.component';
import { PaymentsPageComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/payments-page/payments-page.component';
import { OfferSuggestionsComponent } from './ui/pages/user-dashboard-pages/user-export-offer-suggestions/offer-suggestions/offer-suggestions.component';
import { AdminOperationComponent } from './ui/pages/admin-dashboard-pages/admin-manage-orders-page/admin-operation/admin-operation.component';
import { Role } from './domain/models/Role';
import { AdminManageExportOffersPageComponent } from './ui/pages/admin-dashboard-pages/admin-manage-export-offers-page/admin-manage-export-offers-page.component';
import { AdminEditExportOfferComponent } from './ui/pages/admin-dashboard-pages/admin-manage-export-offers-page/admin-edit-export-offer/admin-edit-export-offer.component';
import { AdminManageSpeciesComponent } from './ui/pages/admin-dashboard-pages/admin-manage-species/admin-manage-species.component';
import { AdminUsersComponent } from './ui/pages/admin-dashboard-pages/admin-users/admin-users.component';
import { AdminEditUserComponent } from './ui/pages/admin-dashboard-pages/admin-users/admin-edit-user/admin-edit-user.component';
import { AdminNewSpeciesComponent } from './ui/pages/admin-dashboard-pages/admin-manage-species/admin-new-species/admin-new-species.component';
import { UserImportRequestComponent } from './ui/pages/user-dashboard-pages/user-import-request/user-import-request.component';
import { NewImportRequestComponent } from './ui/pages/user-dashboard-pages/user-import-request/new-import-request/new-import-request.component';
import { EditImportRequestComponent } from './ui/pages/user-dashboard-pages/user-import-request/edit-import-request/edit-import-request.component';
import { ViewImportRequestOffersComponent } from './ui/pages/user-dashboard-pages/user-import-request/view-import-request-offers/view-import-request-offers.component';
import { UserClosedSaleComponent } from './ui/pages/user-dashboard-pages/user-closed-sale/user-closed-sale.component';
import { UserCreateClosedSaleComponent } from './ui/pages/user-dashboard-pages/user-closed-sale/create-closed-sale/user-create-closed-sale/user-create-closed-sale.component';
import { UserEditClosedSaleComponent } from './ui/pages/user-dashboard-pages/user-closed-sale/user-edit-closed-sale/user-edit-closed-sale.component';
import { ExporterClosedSaleOrdersComponent } from './ui/pages/user-dashboard-pages/user-closed-sale/exporter-closed-sale-orders/exporter-closed-sale-orders.component';
import { UserClosedSaleImportOrderDetailComponent } from './ui/pages/user-dashboard-pages/user-closed-sale/user-closed-sale-import-order-detail/user-closed-sale-import-order-detail.component';
import { UserClosedSaleExporterVerifyPalletsComponent } from './ui/pages/user-dashboard-pages/user-closed-sale/user-closed-sale-exporter-verify-pallets/user-closed-sale-exporter-verify-pallets.component';
import { ImporterClosedSaleOrdersComponent } from './ui/pages/user-dashboard-pages/user-closed-sale/importer-closed-sale-orders/importer-closed-sale-orders.component';
import { UserPanelComponent } from './ui/pages/user-dashboard-pages/user-panel/user-panel.component';
import { UserImportOrdersApprovedComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/user-import-orders-approved/user-import-orders-approved.component';
import { UserImportOrdersPendingComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/user-import-orders-pending/user-import-orders-pending.component';
import { UserImportOrdersConfirmedComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/user-import-orders-confirmed/user-import-orders-confirmed.component';
import { UserImportOrdersCreatedComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/user-import-orders-created/user-import-orders-created.component';
import { UserImportOrdersCurrentComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/user-import-orders-current/user-import-orders-current.component';
import { UserImportOrdersPurchaseComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/user-import-orders-purchase/user-import-orders-purchase.component';
import { UserClosedSalePaymentsComponent } from './ui/pages/user-dashboard-pages/user-closed-sale/user-closed-sale-payments/user-closed-sale-payments.component';
import { AdminNotificationsComponent } from './ui/pages/admin-dashboard-pages/admin-notifications/admin-notifications.component';
import { AdminMasterLoadPageComponent } from './ui/pages/admin-dashboard-pages/admin-master-load-page/admin-master-load-page.component';
import { AdminLoadInvoiceComponent } from './ui/pages/admin-dashboard-pages/admin-load-invoice/admin-load-invoice.component';
import { AdminLoadInvoiceListComponent } from './ui/pages/admin-dashboard-pages/admin-load-invoice/admin-load-invoice-list/admin-load-invoice-list.component';
import { AdminEditPalletsComponent } from './ui/pages/admin-dashboard-pages/admin-manage-orders-page/admin-edit-pallets/admin-edit-pallets.component';
import { SignupQccompanyPageComponent } from './ui/pages/signup-qccompany-page/signup-qccompany-page.component';
import { QcUserReviewsComponent } from './ui/pages/qc-user-dashboard-pages/qc-user-reviews/qc-user-reviews.component';
import { QcUserOriginReviewComponent } from './ui/pages/qc-user-dashboard-pages/qc-user-origin-review/qc-user-origin-review.component';
import { QcUserOriginReviewedComponent } from './ui/pages/qc-user-dashboard-pages/qc-user-origin-reviewed/qc-user-origin-reviewed.component';
import { ForwarderCreateOrderPageComponent } from './ui/pages/forwarder-pages/forwarder-create-order-page/forwarder-create-order-page.component';
import { AdminCreateUserComponent } from './ui/pages/admin-dashboard-pages/admin-users/admin-create-user/admin-create-user.component';
import { AdminExporterImportersPageComponent } from './ui/pages/admin-dashboard-pages/admin-users/admin-exporter-importers-page/admin-exporter-importers-page.component';
import { FrozenFruitExportOffersComponent } from './ui/pages/user-dashboard-pages/user-frozen-fruit-export-offer/frozen-fruit-export-offers/frozen-fruit-export-offers.component';
import { FrozenFruitExportOfferCreateComponent } from './ui/pages/user-dashboard-pages/user-frozen-fruit-export-offer/frozen-fruit-export-offer-create/frozen-fruit-export-offer-create.component';
import { FrozenFruitExportOffersActiveComponent } from './ui/pages/user-dashboard-pages/user-frozen-fruit-export-offer/frozen-fruit-export-offers-active/frozen-fruit-export-offers-active.component';
import { FrozenFruitExportOffersInactiveComponent } from './ui/pages/user-dashboard-pages/user-frozen-fruit-export-offer/frozen-fruit-export-offers-inactive/frozen-fruit-export-offers-inactive.component';
import { FrozenFruitExportOfferEditComponent } from './ui/pages/user-dashboard-pages/user-frozen-fruit-export-offer/frozen-fruit-export-offer-edit/frozen-fruit-export-offer-edit.component';
import { FrozenFruitExportOfferEditPicturesComponent } from './ui/pages/user-dashboard-pages/user-frozen-fruit-export-offer/frozen-fruit-export-offer-edit-pictures/frozen-fruit-export-offer-edit-pictures.component';
import { FrozenFruitExportOfferEditDocumentsComponent } from './ui/pages/user-dashboard-pages/user-frozen-fruit-export-offer/frozen-fruit-export-offer-edit-documents/frozen-fruit-export-offer-edit-documents.component';
import { FrozenFruitPurchaseOrdersPageComponent } from './ui/pages/purchase-orders-page/frozen-fruit-purchase-orders-page/frozen-fruit-purchase-orders-page.component';
import { FrozenFruitVerifyPalletsComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/verify-pallets-page/frozen-fruit-verify-pallets/frozen-fruit-verify-pallets.component';
import { QcUserFrozenFruitOriginReviewComponent } from './ui/pages/qc-user-dashboard-pages/qc-user-frozen-fruit-origin-review/qc-user-frozen-fruit-origin-review.component';
import { AdminFrozenFruitVerifyPalletsComponent } from './ui/pages/admin-dashboard-pages/admin-manage-orders-page/admin-frozen-fruit-verify-pallets/admin-frozen-fruit-verify-pallets.component';
import { AdminInvitationCodesComponent } from './ui/pages/admin-dashboard-pages/admin-invitation-codes/admin-invitation-codes.component';
import { ExportOfferEditAdditionalInfoComponent } from './ui/pages/user-dashboard-pages/user-export-offers/export-offer-edit-additional-info/export-offer-edit-additional-info.component';
import { ExportOfferDocumentsPageComponent } from './ui/pages/user-dashboard-pages/user-export-offers/export-offer-documents-page/export-offer-documents-page.component';
import { UserLoadOrdersComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/user-load-orders/user-load-orders.component';
import { UserLoadPalletsOrdersComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/user-load-pallets-orders/user-load-pallets-orders.component';
import { QcUserReviewDocumentsComponent } from './ui/pages/qc-user-dashboard-pages/qc-user-review-documents/qc-user-review-documents.component';
import { AdminManageQcReviewsComponent } from './ui/pages/admin-dashboard-pages/admin-manage-qc-reviews/admin-manage-qc-reviews.component';
import { AdminQcReviewComponent } from './ui/pages/admin-dashboard-pages/admin-qc-review/admin-qc-review.component';
import { AdminQcReviewDocumentsComponent } from './ui/pages/admin-dashboard-pages/admin-qc-review-documents/admin-qc-review-documents.component';
import { UserDirectSaleFormComponent } from './ui/pages/user-dashboard-pages/user-closed-sale/user-direct-sale-form/user-direct-sale-form.component';
import { UserDirectSaleDocumentsPageComponent } from './ui/pages/user-dashboard-pages/user-closed-sale/user-direct-sale-documents-page/user-direct-sale-documents-page.component';
import { UserDirectSaleEditAdditionalInfoComponent } from './ui/pages/user-dashboard-pages/user-closed-sale/user-direct-sale-edit-additional-info/user-direct-sale-edit-additional-info.component';
import { SignupValidationtokenComponent } from './ui/pages/signup-page/signup-validationtoken/signup-validationtoken.component';
import { ForwarderUserReviewsComponent } from './ui/pages/forwarder-user-dashboard-pages/forwarder-user-reviews/forwarder-user-reviews.component';
import { ForwarderUserOriginReviewComponent } from './ui/pages/forwarder-user-dashboard-pages/forwarder-user-origin-review/forwarder-user-origin-review.component';
import { AdminForwardersComponent } from './ui/pages/admin-dashboard-pages/admin-forwarders/admin-forwarders.component';
import { AdminCreateForwarderComponent } from './ui/pages/admin-dashboard-pages/admin-forwarders/admin-create-forwarder/admin-create-forwarder.component';
import { AdminEditForwarderComponent } from './ui/pages/admin-dashboard-pages/admin-forwarders/admin-edit-forwarder/admin-edit-forwarder.component';
import { ForwarderUserOriginReviewedComponent } from './ui/pages/forwarder-user-dashboard-pages/forwarder-user-origin-reviewed/forwarder-user-origin-reviewed.component';
import { ForwarderUsersComponent } from './ui/pages/forwarder-user-dashboard-pages/forwarder-users/forwarder-users.component';
import { UserProgramRequestCreateComponent } from './ui/pages/user-dashboard-pages/user-program-request/user-program-request-create/user-program-request-create.component';
import { UserProgramEditComponent } from './ui/pages/user-dashboard-pages/user-program-request/user-program-edit/user-program-edit.component';
import { ForwarderDeliveryComponent } from './ui/pages/forwarder-user-dashboard-pages/forwarder-delivery/forwarder-delivery.component'
import { AdminCustomAgentsComponent } from './ui/pages/admin-dashboard-pages/admin-custom-agents/admin-custom-agents.component';
import { AdminCreateCustomAgentComponent } from './ui/pages/admin-dashboard-pages/admin-custom-agents/admin-create-custom-agent/admin-create-custom-agent.component';
import { AdminEditCustomAgentComponent } from './ui/pages/admin-dashboard-pages/admin-custom-agents/admin-edit-custom-agent/admin-edit-custom-agent.component';
import { CustomAgentReviewsComponent } from './ui/pages/custom-agent-dashboard-pages/custom-agent-reviews/custom-agent-reviews.component';
import { CustomAgentOriginReviewComponent } from './ui/pages/custom-agent-dashboard-pages/custom-agent-origin-review/custom-agent-origin-review.component';
import { CustomAgentOriginReviewedComponent } from './ui/pages/custom-agent-dashboard-pages/custom-agent-origin-reviewed/custom-agent-origin-reviewed.component';
import { CustomAgentUsersComponent } from './ui/pages/custom-agent-dashboard-pages/custom-agent-users/custom-agent-users.component'
import { ForwarderImportOrderComponent } from './ui/pages/forwarder-user-dashboard-pages/forwarder-import-order/forwarder-import-order.component';
import { ForwarderOrderDetailComponent } from './ui/pages/forwarder-user-dashboard-pages/forwarder-import-order/forwarder-order-detail/forwarder-order-detail.component';
import { ForwarderEditImportOrderComponent } from './ui/pages/forwarder-user-dashboard-pages/forwarder-import-order/forwarder-edit-import-order/forwarder-edit-import-order.component';
import { UserImportOrdersForwarderComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/user-import-orders-forwarder/user-import-orders-forwarder.component';
import { OrderNotFoundComponent } from './ui/pages/order-not-found/order-not-found.component';
import { QcOrderDetailComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/qc-order-detail/qc-order-detail.component';
import { QcOrderPaymentComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/qc-order-payment/qc-order-payment.component';
import { ExternalMarketplacePageComponent } from './ui/pages/external-marketplace-page/external-marketplace-page.component';
import { OfferDetailComponent } from './ui/pages/offer-detail/offer-detail.component';
import { ProductDetailComponent } from './ui/pages/product-detail/product-detail.component';
import { ImportRequestDetailPageComponent } from './ui/pages/marketplace-page/import-request-detail-page/import-request-detail-page.component';
import { ComexVirtualPageComponent } from './ui/pages/external-pages/comex-virtual-page/comex-virtual-page.component';
import { UserLoadMasterOrdersComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/user-load-master-orders/user-load-master-orders.component';
import { UserLoadContainersOrdersComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/user-load-containers-orders/user-load-containers-orders.component';
import { UserLoadOrdersProgramComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/user-load-orders-program/user-load-orders-program.component';
import { UserLoadMasterOrdersProgramComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/user-load-master-orders-program/user-load-master-orders-program.component';
import { UserLoadContainersOrdersProgramComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/user-load-containers-orders-program/user-load-containers-orders-program.component';
import { UserLoadPalletsOrdersProgramComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/user-load-pallets-orders-program/user-load-pallets-orders-program.component';
import { PackingListViewComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/packing-list-view/packing-list-view.component';
import { InstructiveViewComponent } from './ui/pages/user-dashboard-pages/user-purchase-orders/instructive-view/instructive-view.component';
import { AdminUploadsComponent } from './ui/pages/admin-dashboard-pages/admin-uploads/admin-uploads.component';
import { AdminUploadsDeliveryComponent } from './ui/pages/admin-dashboard-pages/admin-uploads/admin-uploads-delivery/admin-uploads-delivery.component';
import { AdminManageProgramOrdersComponent } from './ui/pages/admin-dashboard-pages/admin-manage-program-orders/admin-manage-program-orders.component';
import { ProcessFruztyPageComponent } from './ui/pages/process-fruzty-page/process-fruzty-page.component';
import { InfoMarketplaceDirectSalePageComponent } from './ui/pages/info-marketplace-direct-sale-page/info-marketplace-direct-sale-page.component';
import { BenefitCommercialFocusPageComponent } from './ui/pages/benefit-commercial-focus-page/benefit-commercial-focus-page.component';
import { InternationalMarketplaceComponent } from './ui/pages/external-pages/international-marketplace/international-marketplace.component';
import { VirtualProcurementComponent } from './ui/pages/external-pages/virtual-procurement/virtual-procurement.component';
import { AutomatedSettlementsComponent } from './ui/pages/external-pages/automated-settlements/automated-settlements.component';
import { AdminUserPanelComponent } from './ui/pages/admin-dashboard-pages/admin-user-panel/admin-user-panel.component';
import { AdminContactInfoComponent } from './ui/pages/admin-dashboard-pages/admin-contact-info/admin-contact-info.component';
import { AdminChangePasswordComponent } from './ui/pages/admin-dashboard-pages/admin-change-password/admin-change-password.component';
import { FlowSelectionPageComponent } from './ui/pages/flow-selection-page/flow-selection-page.component';
import { SelectedFlowGuard } from './infrastructure/guards/selected-flow.guard';
import { UserPalletStockComponent } from './ui/pages/user-dashboard-pages/user-pallet-stock/user-pallet-stock.component';
import { AdminOrderManagementComponent } from './ui/pages/admin-dashboard-pages/admin-manage-orders-page/admin-order-management/admin-order-management.component';
import { AdminEditSpeciesComponent } from './ui/pages/admin-dashboard-pages/admin-manage-species/admin-edit-species/admin-edit-species.component';
import { FormatPalletStockComponent } from './ui/pages/user-dashboard-pages/format-pallet-stock/format-pallet-stock.component';
import { UserAssignStockProgramComponent } from './ui/pages/user-dashboard-pages/user-assign-stock-program/user-assign-stock-program.component';
import { UserAssignStockOrderComponent } from './ui/pages/user-dashboard-pages/user-assign-stock-order/user-assign-stock-order.component';
import { AdminUploadsConsigneesNotifiersComponent } from './ui/pages/admin-dashboard-pages/admin-uploads/admin-uploads-consignees-notifiers/admin-uploads-consignees-notifiers.component';
import { AdminUploadProgramsComponent } from './ui/pages/admin-dashboard-pages/admin-uploads/admin-upload-programs/admin-upload-programs.component';
import { AdminDownloadedDocumentsComponent } from './ui/pages/admin-dashboard-pages/admin-downloaded-documents/admin-downloaded-documents.component';
import { AdminDownloadedDocumentsReportComponent } from './ui/pages/admin-dashboard-pages/admin-downloaded-documents-report/admin-downloaded-documents-report.component';
import { AdminUploadProgramsUpdateComponent } from './ui/pages/admin-dashboard-pages/admin-uploads/admin-upload-programs-update/admin-upload-programs-update.component';
import { AdminProgramsReportPageComponent } from './ui/pages/admin-dashboard-pages/admin-programs-report-page/admin-programs-report-page.component';
import { AdminAssignedDocumentsReportComponent } from './ui/pages/admin-dashboard-pages/admin-assigned-documents-report/admin-assigned-documents-report.component';
import { AdminManagePortsAirportsComponent } from './ui/pages/admin-dashboard-pages/admin-manage-data/admin-manage-ports-airports/admin-manage-ports-airports.component';
import { AdminManageCountriesComponent } from './ui/pages/admin-dashboard-pages/admin-manage-data/admin-manage-countries/admin-manage-countries.component';
import { UserEditStockProgramComponent } from './ui/pages/user-edit-stock-program/user-edit-stock-program.component';
import { AdminPalletStockComponent } from './ui/pages/admin-dashboard-pages/admin-pallet-stock/admin-pallet-stock.component';

const routes: Routes = [
  {
    path: AppRoutes.homePage,
    component: HomePageComponent,
    pathMatch: 'full'
  },
  {
    path: AppRoutes.forbiddenPage,
    component: ForbiddenPageComponent
  },
  {
    path: AppRoutes.login,
    component: LoginPageComponent
  },
  {
    path: AppRoutes.signup,
    component: SignupPageContactComponent
  },
  {
    path: AppRoutes.signup + '/:userJoinRequestId',
    component: SignupPageContactComponent
  },
  {
    path: AppRoutes.signupCompany,
    component: SignupPageCompanyComponent
  },
  {
    path: AppRoutes.signupImporterAddInfo,
    component: SignupPageImportAddInfoComponent
  },
  {
    path: AppRoutes.signupInvitationCode,
    component: SignupInvitationcodeComponent
  },
  {
    path: AppRoutes.userDashboard,
    component: UserDashboardComponent
  },
  {
    path: AppRoutes.userContactInfo,
    component: UserContactInfoComponent
  },
  {
    path: AppRoutes.adminContactInfo,
    component: AdminContactInfoComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.userCompanyInfo,
    component: UserCompanyInfoComponent
  },
  {
    path: AppRoutes.userProducts,
    component: UserProductsComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userFridgestorages,
    component: UserFridgestoragesComponent,
    data: {
      roles: ['Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.fridgestorageForm + '/:fridgestorageId',
    component: FridgestorageFormComponent,
    data: {
      roles: ['Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userConsignees,
    component: UserConsigneesComponent,
    data: {
      roles: ['Importer', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.consigneeForm + '/:consigneeId',
    component: ConsigneeFormComponent,
    data: {
      roles: ['Importer', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userNotifiers,
    component: UserNotifiesComponent,
    data: {
      roles: ['Importer', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.notifierForm + '/:notifierId',
    component: NotifierFormComponent,
    data: {
      roles: ['Importer', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userChangePassword,
    component: UserChangePasswordComponent
  },
  {
    path: AppRoutes.adminChangePassword,
    component: AdminChangePasswordComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.resetPasswordRequestPage,
    component: ResetPasswordRequestPageComponent
  },
  {
    path: AppRoutes.resetPasswordPage + '/:token',
    component: ResetPasswordPageComponent
  },
  {
    path: AppRoutes.userNotifications,
    component: UserNotificationsComponent
  },
  {
    path: AppRoutes.userNotificationsConfig,
    component: UserNotificationsConfigComponent
  },
  {
    path: AppRoutes.userSupport,
    component: UserSupportComponent
  },
  {
    path: AppRoutes.offerDetail + '/:adsCode',
    component: OfferDetailComponent
  },
  {
    path: AppRoutes.productDetail + '/:exportOfferGuid',
    component: ProductDetailComponent,
    data: {
      roles: ['Importer', 'Admin', "Exporter"]
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.externalMarketplace,
    component: ExternalMarketplacePageComponent
  },
  {
    path: AppRoutes.marketplacePage,
    component: MarketplacePageComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userExportOffers,
    component: UserExportOffersComponent,
    data: {
      roles: ['Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.newExportOffer,
    component: NewExportOfferComponent,
    data: {
      roles: ['Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.editExportOffer + '/:exportOfferId',
    component: EditExportOfferComponent,
    data: {
      roles: ['Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.exportOfferEditAdditionalInfo + '/:exportOfferId',
    component: ExportOfferEditAdditionalInfoComponent,
    data: {
      roles: ['Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.exportOfferDocumentsPage + '/:exportOfferId',
    component: ExportOfferDocumentsPageComponent,
    data: {
      roles: ['Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userProductCertificates,
    component: UserProductCertificatesComponent,
    data: {
      roles: ['Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.productCertificateForm + '/:productCertificateId',
    component: ProductCertificateFormComponent,
    data: {
      roles: ['Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.purchaseOrdersPage,
    component: PurchaseOrdersPageComponent,
    data: {
      roles: ['Importer', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.containerOrderPage,
    component: ContainerOrderPageComponent,
    data: {
      roles: ['Importer', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userPurchaseOrders,
    component: UserPurchaseOrdersComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.verifyPalletsPage + '/:orderDetailId',
    component: VerifyPalletsPageComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userOrderDetailPage + '/:orderId',
    component: OrderDetailComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userConfirmPurchasePage + '/:orderId',
    component: ConfirmPurchasePageComponent,
    data: {
      roles: ['Importer', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userPaymentsPage + '/:importOrderId',
    component: PaymentsPageComponent,
    data: {
      roles: ['Importer', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.adminManageOrderPage,
    component: AdminManageOrdersPageComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminManageProgramOrderPage,
    component: AdminManageProgramOrdersComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.userBargaining,
    component: UserBargainingComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.bargainingDetail + '/:negotiationId',
    component: BargainingDetailComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userExportOfferSuggestionPage,
    component: UserExportOfferSuggestionsComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userOfferSuggestionsPage + '/:suggestionId',
    component: OfferSuggestionsComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userProgramRequestCreate,
    component: UserProgramRequestCreateComponent,
    data: {
      roles: ['Importer', 'Admin', 'Exporter']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]

  },
  {
    path: AppRoutes.userProgramRequestDirectSaleCreate + '/:programRequestId',
    component: UserDirectSaleFormComponent,
    data: {
      roles: ['Importer', 'Admin', 'Exporter']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]

  },
  {
    path: AppRoutes.userProgramRequestEdit + '/:programRequestId',
    component: UserProgramEditComponent,
    data: {
      roles: ['Importer', 'Admin', 'Exporter']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.adminOrderManagement + '/:orderId',
    component: AdminOrderManagementComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminVerifyPallets + '/:orderDetailId',
    component: AdminVerifyPalletsComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminCompleteOrder + '/:orderDetailId',
    component: AdminCompleteOrderComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminMarketplaceExportOfferPage,
    component: AdminManageExportOffersPageComponent,
    data:{
      roles: ['Admin'],
      saleType: 'marketplace'
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminProgramExportOfferPage,
    component: AdminManageExportOffersPageComponent,
    data:{
      roles: ['Admin'],
      saleType: 'program'
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminDownloadedDocumentsPage,
    component: AdminDownloadedDocumentsComponent,
    data:{
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminDownloadedDocumentsReport,
    component: AdminDownloadedDocumentsReportComponent,
    data:{
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminUsers,
    component: AdminUsersComponent,
    data:{
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminExportOfferEdit + '/:exportOfferId',
    component: AdminEditExportOfferComponent,
    data:{
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminEditUser + '/:profileId',
    component: AdminEditUserComponent,
    data:{
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminSpecies,
    component: AdminManageSpeciesComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminSpeciesNew,
    component: AdminNewSpeciesComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminSpeciesEdit + '/:specieId',
    component: AdminEditSpeciesComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminNotifications,
    component: AdminNotificationsComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminMasterLoadPage,
    component: AdminMasterLoadPageComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminLoadInvoice,
    component: AdminLoadInvoiceComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminLoadInvoiceList,
    component: AdminLoadInvoiceListComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminProgramsReport,
    component: AdminProgramsReportPageComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminAssignedDocumentsReport,
    component: AdminAssignedDocumentsReportComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminEditPallets + '/:orderDetailId',
    component: AdminEditPalletsComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminUploadPalletsProgram,
    component: AdminUploadsComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.userImportRequest,
    component: UserImportRequestComponent,
    data: {
      roles: ['Importer', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userNewImportRequest,
    component: NewImportRequestComponent,
    data: {
      roles: ['Importer', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.importRequestDetail + '/:importRequestGuid',
    component: ImportRequestDetailPageComponent,
    data: {
      roles: ['Importer', 'Admin', 'Exporter']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.externalImportRequestDetail + '/:adsCode',
    component: ImportRequestDetailPageComponent,
  },
  {
    path: AppRoutes.userEditImportRequest + '/:importRequestId',
    component: EditImportRequestComponent,
    data: {
      roles: ['Importer', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userViewImportRequest + '/:importRequestId',
    component: ViewImportRequestOffersComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userClosedSales,
    component: UserClosedSaleComponent,
    data: {
      roles: ['Importer','Exporter', 'Admin'],
      type: 'program'
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userClosedSalesPurchaseOrders,
    component: UserClosedSaleComponent,
    data: {
      roles: ['Importer','Exporter', 'Admin'],
      type: 'purchase-orders'
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userCreateClosedSale,
    component: UserCreateClosedSaleComponent,
    data: {
      roles: ['Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userEditClosedSale + '/:exportOfferId',
    component: UserEditClosedSaleComponent,
    data: {
      roles: ['Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.exporterClosedSaleOrdersPage + '/:directSaleProgramId',
    component: ExporterClosedSaleOrdersComponent,
    data: {
      roles: ['Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userClosedSaleImportOrderDetailPage + '/:orderId/:directSaleProgramId',
    component: UserClosedSaleImportOrderDetailComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userClosedSaleExporterVerifyPallets + '/:orderDetailId/:directSaleProgramId',
    component: UserClosedSaleExporterVerifyPalletsComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userClosedSalePaymentsPage + '/:importOrderId/:directSaleProgramId',
    component: UserClosedSalePaymentsComponent,
    data: {
      roles: ['Importer', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.importerClosedSaleOrdersPage + '/:directSaleProgramId',
    component: ImporterClosedSaleOrdersComponent,
    data: {
      roles: ['Importer', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userPanelPage,
    component: UserPanelComponent,
    data: {
      roles: ['Importer', 'Exporter', 'QCUser', 'Admin', 'Forwarder']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.adminUserPanelPage,
    component: AdminUserPanelComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.userImportOrdersPending,
    component: UserImportOrdersPendingComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userImportOrdersApproved,
    component: UserImportOrdersApprovedComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userImportOrdersConfirmed,
    component: UserImportOrdersConfirmedComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userImportOrdersCreated,
    component: UserImportOrdersCreatedComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userImportOrdersCurrent,
    component: UserImportOrdersCurrentComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userLoadOrders,
    component: UserLoadOrdersComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userLoadOrdersProgram,
    component: UserLoadOrdersProgramComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.packingListView  + '/:importOrderDetailGuid',
    component: PackingListViewComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.instructiveView  + '/:importOrderDetailGuid',
    component: InstructiveViewComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userLoadMasterOrders,
    component: UserLoadMasterOrdersComponent,
    data: {
     roles: ['Importer', 'Exporter']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userLoadMasterOrdersProgram,
    component: UserLoadMasterOrdersProgramComponent,
    data: {
     roles: ['Importer', 'Exporter']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userLoadContainersOrders,
    component: UserLoadContainersOrdersComponent,
    data: {
     roles: ['Importer', 'Exporter']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userLoadContainersOrdersProgram,
    component: UserLoadContainersOrdersProgramComponent,
    data: {
     roles: ['Importer', 'Exporter']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userLoadPalletsOrders,
    component: UserLoadPalletsOrdersComponent,
    data: {
     roles: ['Importer', 'Exporter']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userLoadPalletsOrdersProgram,
    component: UserLoadPalletsOrdersProgramComponent,
    data: {
     roles: ['Importer', 'Exporter']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userImportOrdersPurchase,
    component: UserImportOrdersPurchaseComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.signupQCCompany,
    component: SignupQccompanyPageComponent
  },
  {
    path: AppRoutes.qcUserReviews,
    component: QcUserReviewsComponent,
    data: {
      roles: ['QCUser', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.qcUserOriginReview + '/:reviewId',
    component: QcUserOriginReviewComponent,
    data: {
      roles: ['QCUser', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.qcUserOriginReviewed,
    component: QcUserOriginReviewedComponent,
    data: {
      roles: ['QCUser', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.forwarderCreateOrderPage,
    component: ForwarderCreateOrderPageComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminCreateUserPage,
    component: AdminCreateUserComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminExporterImportersPage + '/:exporterId',
    component: AdminExporterImportersPageComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.userFrozenFruitExportOfferCreate,
    component: FrozenFruitExportOfferCreateComponent,
    data: {
      roles: ['Admin', 'Exporter']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userFrozenFruitExportOffersActivePage,
    component: FrozenFruitExportOffersActiveComponent,
    data: {
      roles: ['Admin', 'Exporter']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userFrozenFruitExportOffersInactivePage,
    component: FrozenFruitExportOffersInactiveComponent,
    data: {
      roles: ['Admin', 'Exporter']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userFrozenFruitExportOfferEdit + '/:frozenFruitExportOfferId',
    component: FrozenFruitExportOfferEditComponent,
    data: {
      roles: ['Admin', 'Exporter']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userFrozenFruitExportOfferEditPictures + '/:frozenFruitExportOfferId',
    component: FrozenFruitExportOfferEditPicturesComponent,
    data: {
      roles: ['Admin', 'Exporter']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userFrozenFruitExportOfferEditDocuments + '/:frozenFruitExportOfferId',
    component: FrozenFruitExportOfferEditDocumentsComponent,
    data: {
      roles: ['Admin', 'Exporter']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userFrozenFruitPurchaseOrdersPage,
    component: FrozenFruitPurchaseOrdersPageComponent,
    data: {
      roles: ['Admin', 'Importer']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userFrozenFruitVerifyPalletsPage + '/:orderDetailId',
    component: FrozenFruitVerifyPalletsComponent,
    data: {
      roles: ['Admin', 'Exporter']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.qcUserFrozenFruitOriginReviewPage + '/:orderDetailId',
    component: QcUserFrozenFruitOriginReviewComponent,
    data: {
      roles: ['Admin', 'QCUser']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminFrozenFruitVerifyPalletsPage + '/:orderDetailId',
    component: AdminFrozenFruitVerifyPalletsComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminInvitationCodes,
    component: AdminInvitationCodesComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.qcUserReviewDocuments + '/:reviewId',
    component: QcUserReviewDocumentsComponent,
    data: {
      roles: ['Admin', 'QCUser']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminManageQCReviews,
    component: AdminManageQcReviewsComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminQCReview + '/:reviewId',
    component: AdminQcReviewComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminQCReviewDocuments + '/:reviewId',
    component: AdminQcReviewDocumentsComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.userDirectSaleCreate,
    component: UserDirectSaleFormComponent,
    data: {
      roles: ['Admin', 'Exporter']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userDirectSaleEdit + '/:guid',
    component: UserDirectSaleFormComponent,
    data: {
      roles: ['Admin', 'Exporter']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userDirectSaleDocuments + '/:exportOfferId',
    component: UserDirectSaleDocumentsPageComponent,
    data: {
      roles: ['Admin', 'Exporter']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userDirectSaleEditAdditionalInfo + '/:exportOfferId',
    component: UserDirectSaleEditAdditionalInfoComponent,
    data: {
      roles: ['Admin', 'Exporter']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.forwarderUserReviews,
    component: ForwarderUserReviewsComponent,
    data: {
      roles: ['Admin', 'Forwarder']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.forwarderUserOriginReview + '/:reviewId',
    component: ForwarderUserOriginReviewComponent,
    data: {
      roles: ['Admin', 'Forwarder']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminForwarder,
    component: AdminForwardersComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminUploadPreBl,
    component: AdminUploadsDeliveryComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminUploadConsigneeNotifier,
    component: AdminUploadsConsigneesNotifiersComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminUploadCreatePrograms,
    component: AdminUploadProgramsComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminUploadUpdatePrograms,
    component: AdminUploadProgramsUpdateComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminPortsAirportsData,
    component: AdminManagePortsAirportsComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminCountriesData,
    component: AdminManageCountriesComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminCreateForwarderPage,
    component: AdminCreateForwarderComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminEditForwarderPage + '/:forwarderId',
    component: AdminEditForwarderComponent,
    data:{
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.forwarderUserOriginReviewed,
    component: ForwarderUserOriginReviewedComponent,
    data: {
      roles: ['Admin', 'Forwarder']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.forwarderUsers,
    component: ForwarderUsersComponent,
    data: {
      roles: ['Forwarder']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.forwarderUsersDelivery + '/:orderId',
    component: ForwarderDeliveryComponent,
    data: {
      roles: ['Forwarder']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminCustomAgent,
    component: AdminCustomAgentsComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminCreateCustomAgentPage,
    component: AdminCreateCustomAgentComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminEditCustomAgentPage + '/:customAgentId',
    component: AdminEditCustomAgentComponent,
    data:{
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.customAgentUserReviews,
    component: CustomAgentReviewsComponent,
    data: {
      roles: ['Admin', 'CustomAgent']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.customAgentUserOriginReview + '/:reviewId',
    component: CustomAgentOriginReviewComponent,
    data: {
      roles: ['Admin', 'CustomAgent']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.customAgentUserOriginReviewed,
    component: CustomAgentOriginReviewedComponent,
    data: {
      roles: ['Admin', 'CustomAgent']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.customAgentUsers,
    component: CustomAgentUsersComponent,
    data: {
      roles: ['CustomAgent']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.forwarderImportOrders,
    component: ForwarderImportOrderComponent,
    data: {
      roles: ['Forwarder']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.forwarderImportOrderDetail + '/:orderId',
    component: ForwarderOrderDetailComponent,
    data: {
      roles: ['Forwarder']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.forwarderImportOrderEdit + '/:importOrderId',
    component: ForwarderEditImportOrderComponent,
    data: {
      roles: ['Forwarder']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.userImportOrdersForwarder,
    component: UserImportOrdersForwarderComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.userValidationToken + '/:token',
    component: SignupValidationtokenComponent
  },
  {
    path: AppRoutes.userOrderNotFound,
    component: OrderNotFoundComponent
  },
  {
    path: AppRoutes.qcOrderDetailPage + '/:orderId',
    component: QcOrderDetailComponent,
    data: {
      roles: ['Importer', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.qcOrderPaymentPage + '/:orderId',
    component: QcOrderPaymentComponent,
    data: {
      roles: ['Importer', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard, SelectedFlowGuard]
  },
  {
    path: AppRoutes.flowSelectionPage,
    component: FlowSelectionPageComponent,
    data: {
      roles: ['Importer', 'Exporter']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.userStockPallet,
    component: UserPalletStockComponent,
    data: {
      roles: ['Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.adminStockPallet,
    component: AdminPalletStockComponent,
    data: {
      roles: ['Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.userFormatStockPallet,
    component: FormatPalletStockComponent,
    data: {
      roles: ['Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard]
  },
  {
    path: AppRoutes.toDoPage,
    component: ComexVirtualPageComponent,
  },
  {
    path: AppRoutes.internationalMarketplacePage,
    component: InternationalMarketplaceComponent,
  },
  {
    path: AppRoutes.virtualProcurementPage,
    component: VirtualProcurementComponent,
  },
  {
    path: AppRoutes.automatedSettlementsPage,
    component: AutomatedSettlementsComponent,
  },
  {
    path: AppRoutes.processFruztyPage,
    component: ProcessFruztyPageComponent,
  },
  {
    path: AppRoutes.infoMarketplaceDirectSalePage,
    component: InfoMarketplaceDirectSalePageComponent,
  },
  {
    path: AppRoutes.benefitsCommercialFocusPage,
    component: BenefitCommercialFocusPageComponent,
  },
  {
    path: AppRoutes.userAssignStockProgram + "/:programOrderGuid",
    component: UserAssignStockProgramComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard,]
  },
  {
    path: AppRoutes.userEditStockProgram + "/:programOrderGuid",
    component: UserEditStockProgramComponent,
    data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard,]
  },
  {
    path: AppRoutes.userAssignStockOrder + "/:orderDetailGuid",
    component: UserAssignStockOrderComponent,
      data: {
      roles: ['Importer', 'Exporter', 'Admin']
    },
    canActivate: [AuthGuard, RolesGuard,]
  },
  {
    path: '**',
    component: HomePageComponent,
    redirectTo: AppRoutes.homePage
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 74]
    })
],
  exports: [RouterModule],
})
export class AppRoutingModule { }
